import { KEYBOARD_KEYS } from "@netapp/bxp-design-system-react";
import _ from "lodash";
import { useCallback } from "react";

export const useCategoriesNavigation = (isHomePageEnabled) => {
    return useCallback((e, currentIndex, categoryRefs) => {
        const { favouritesRef, homeRef, categoriesRefs } = categoryRefs;
        
        const allCategoryRefs = _.filter([
            favouritesRef,
            ...(isHomePageEnabled ? [homeRef] : []),
            ...categoriesRefs.current
        ], Boolean);

        if (allCategoryRefs.length === 0) {
            return;
        }

        const { key } = e;
        let nextIndex = currentIndex;

        const hasFavourites = !_.isNull(favouritesRef?.current);
        const startIndex = hasFavourites ? 0 : 1;

        switch (key) {
            case KEYBOARD_KEYS.ARROW_DOWN:
                if (currentIndex === allCategoryRefs.length - 1) {
                    nextIndex = startIndex;
                } else {
                    nextIndex = currentIndex + 1;
                }
                break;
            case KEYBOARD_KEYS.ARROW_UP:
                if (currentIndex === startIndex) {
                    nextIndex = allCategoryRefs.length - 1;
                } else {
                    nextIndex = _.max([currentIndex - 1, startIndex]);
                }
                break;
            default:
                return;
        }

        if (nextIndex !== currentIndex) {
            const nextElement = allCategoryRefs[nextIndex]?.current;
            if (nextElement && typeof nextElement.focus === 'function') {
                nextElement.focus();
            }
        }
    }, [isHomePageEnabled]);
};
